import { useState } from 'react';
// import { Carousel, Image } from 'react-bootstrap';
import { Carousel, Image } from 'antd';
import warehouse from '../../../assets/images/warehouse-pharmacy.jpg';
import { midContentHeight } from '../Home';

function Slider() {

    const [selectedImage, setSelectedImage] = useState(0);
    const [allImages, setAllImages] = useState([
        warehouse
    ]);

    // useEffect(() => {
    //     setInterval(() => {
    //         setSelectedImage(selectedImage => selectedImage > 1 ? 0 : selectedImage + 1)
    //     }, 2500);
    // }, [])

    return (
        <>
            <div style={{
                // width: window.innerWidth / 3
                marginTop: "1.5rem"
            }}>
                <Carousel autoplay autoplaySpeed={2500}
                    style={{
                        boxShadow: "0px 0px 23px -10px #044b7f"
                    }}
                >
                    {/* <Carousel.Item> */}
                    {allImages.map((item, index) => (
                        <Image src={item} key={index}
                            width={"100%"}
                            height={midContentHeight}
                            alt={"ImagePlaceholder" + index}
                        />
                    ))}
                    {/* </Carousel.Item> */}
                </Carousel>


            </div>
        </>
    )
}
export default Slider;